export enum LANExposureArea {
  FEED_BANNER = 'MYP_feed_banner1',
  FEED_TOP_BANNER = 'MYP_feed_banner2',
  REVIEW_END_BANNER = 'review_end_banner',
  EVENT_POPUP = 'event_popup',
  EVENT_POPUP_DARK = 'event_popup_dark',
  HOME_UP_BANNER = 'home_upbanner',
  MISSION_RESULT = 'mission_result',
  MISSION_GOOD_REVIEWER = 'mission_goodreviewer',
}

export enum LANBannerHeight {
  DEFAULT = '80px',
  TALL = '134px',
}
